import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export interface MyEventMesage {
  type: string;
  payload: any;
}
type MyMessageCallback = (payload: any) => void;


@Injectable({
  providedIn: 'root'
})
export class MyEventService {

  private handler = new Subject<MyEventMesage>();

  constructor() { }

  setViewdata(key, data) {
    localStorage.setItem(key, JSON.stringify(data));

    // clean up after 5 seconds.
    setTimeout(() => {
      localStorage.setItem(key, '');
    }, 5000);
  }

  getViewData(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      return undefined;
    }
  }

  broadcast(type: string, payload?: any) {
    if (type.indexOf('.') !== -1) {
      const baseType = type.split('.')[0];
      this.handler.next({ type: baseType + '.*', payload });
    }
    this.handler.next({ type, payload });
  }

  subscribe(type: string, callback: MyMessageCallback): Subscription {
    return this.handler
      .pipe(filter(message => message.type === type || type === '*'))
      .pipe(map(message => message.payload))
      .subscribe(callback);
  }
}

@Injectable()
export class GuardedEvents implements OnDestroy {
  subscriptions: Subscription[] = [];

  guardedOnDestroy?: () => void;
  onGuardedDestroy?: () => void;
  constructor(private service: MyEventService) { }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(s => s.unsubscribe());
    }
    if (this.guardedOnDestroy) {
      this.guardedOnDestroy();
    }
    if (this.onGuardedDestroy) {
      this.onGuardedDestroy();
    }

  }

  subscribeToEvent(key, callback) {
    this.subscriptions.push(this.service.subscribe(key, callback));
  }

  broadcastEvent(key, data?: any) {
    this.service.broadcast(key, data);
  }

}
